module.exports = __webpack_public_path__ + "img/boc.4f04a54c.png";